export const EMPLOYEE_CREATE_LEAVE = 'employeeLeaveManagement@create-leave';
export const EMPLOYEE_ALL_LEAVE = 'employeeLeaveManagement@all-leave';
export const GET_EMPLOYEE_REMAINING_LEAVES = 'employeeLeaveManagement@remaining-leaves';
export const EMPLOYEE_CANCEL_LEAVE = 'employeeLeaveManagement@cancel-leaves';
export const EMPLOYEE_UPDATE_DOCUMENT = 'employeeLeaveManagement@update-document';
export const EMPLOYEE_UPDATE_LEAVE_STATUS = 'employeeLeaveManagement@update-leave-status';